import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { BYPASS_CLIENT_LOGGING } from './logging-context';

@Injectable({
  providedIn: 'root'
})
export class ClientErrorInterceptorService implements HttpInterceptor {
  constructor(private readonly logger: LoggerService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.context.get(BYPASS_CLIENT_LOGGING)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          this.logger.httpError('HttpInterceptor', req.url, error, {
            method: req.method,
            operation: `${req.method} ${this.sanitizePath(req.url)}`
          });
        }

        return throwError(() => error);
      })
    );
  }

  private sanitizePath(value: string): string {
    try {
      return new URL(value, window.location.origin).pathname;
    } catch {
      return value.split('?')[0];
    }
  }
}